import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export class DailyExpiredFactorListWidget extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            caller: props.Caller,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard/widget/get", { name: 'DailyExpiredFactorListWidget' })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div style={{ maxHeight: "100vh", overflowY: "scroll" }}>
            {
                this.state.data.records.length <= 0 ?
                    <p className="alert alert-fill alert-warning alert-icon text-center">در حال حاضر فاکتوری یافت نشده است</p>
                    : <table>
                        <thead>
                            <th><span>شماره</span></th>
                            <th><span>تاریخ</span></th>
                            <th><span>مبلغ</span></th>
                            <th><span>طرف حساب</span></th>
                        </thead>
                        <tbody>
                        {this.state.data.records.map(record =>
                            <tr id={record.id}>
                                <td><span>{record.number}</span></td>
                                <td><span>{record.dateString}</span></td>
                                <td><span>{this.money(record.total)}</span></td>
                                <td><span>{record.personName}</span></td>
                            </tr>
                            )}
                        </tbody>
                    </table>
            }
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.renderForm(),
            ];

        return contents;
    }
}